export const COLUMN_AGEQ_REPORT = [
  {
    label: 'Patient Name',
    stateValue: 'patientName',
  },
  {
    label: 'NRIC',
    stateValue: 'nric',
  },
  {
    label: 'Screening Date',
    stateValue: 'screeningDate',
  },
];
